/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiteLocationSummaryResponseDto
 */
export interface SiteLocationSummaryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SiteLocationSummaryResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof SiteLocationSummaryResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the SiteLocationSummaryResponseDto interface.
 */
export function instanceOfSiteLocationSummaryResponseDto(value: object): value is SiteLocationSummaryResponseDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SiteLocationSummaryResponseDtoFromJSON(json: any): SiteLocationSummaryResponseDto {
    return SiteLocationSummaryResponseDtoFromJSONTyped(json, false);
}

export function SiteLocationSummaryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteLocationSummaryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
    };
}

export function SiteLocationSummaryResponseDtoToJSON(json: any): SiteLocationSummaryResponseDto {
    return SiteLocationSummaryResponseDtoToJSONTyped(json, false);
}

export function SiteLocationSummaryResponseDtoToJSONTyped(value?: SiteLocationSummaryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

